var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCimNohEasyFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #ebeca0;\n      }\n\n      .st2 {\n        clip-path: url(#clippath-1);\n      }\n\n      .st3 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st4 {\n        fill: #215d64;\n      }\n\n      .st5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 57.9,
    y: 49.8,
    width: 54.3,
    height: 70.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.9,93.1c0,15,12.2,27.1,27.1,27.1s27.1-12.2,27.1-27.1-12.2-27.1-27.1-27.1-27.1,12.2-27.1,27.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 57.9,
    y: 49.8,
    width: 54.3,
    height: 70.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.9,93.1c0-15,12.2-27.1,27.1-27.1s27.1,12.2,27.1,27.1-12.2,27.1-27.1,27.1-27.1-12.2-27.1-27.1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M85.7,79.6l3.6,8.3c.1.3.4.4.6.5l9,.9c.7,0,.9.9.4,1.3l-6.8,6c-.2.2-.3.5-.2.7l2,8.9c.1.7-.6,1.2-1.1.8l-7.8-4.6c-.2-.1-.5-.1-.8,0l-7.8,4.6c-.6.3-1.3-.2-1.1-.8l2-8.9c0-.3,0-.6-.2-.7l-6.8-6c-.5-.4-.2-1.3.4-1.3l9-.9c.3,0,.5-.2.6-.5l3.6-8.3c.3-.6,1.1-.6,1.4,0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M109.9,59.9c.4.2.7.2.9-.2l.3-.4c.2-.4.2-.7-.2-.9l-4.3-2.7c-.4-.2-.7-.2-.9.2l-4.4,6.9c-.2.4-.1.7.2.9l4.3,2.7c.4.2.7.2.9-.2l.3-.4c.2-.4.2-.7-.2-.9l-3-1.9,1.1-1.7,2.6,1.6c.4.2.7.1.9-.2l.2-.3c.2-.4.2-.7-.2-.9l-2.6-1.6,1.2-1.8,3,1.9ZM94.3,60.6l4.8,1.6c.4.1.7,0,.8-.4l.2-.5c.1-.4,0-.7-.4-.8l-3.4-1.2,2.2-6.6c.1-.4,0-.7-.4-.8l-.8-.3c-.4-.1-.7,0-.8.4l-2.6,7.7c-.1.4,0,.7.4.8M89.9,59.7h.8c.4.2.7,0,.8-.4l1.4-8c0-.4-.1-.7-.5-.8h-.8c-.4-.2-.7,0-.8.4l-1.4,8c0,.4.1.7.5.8M84.4,59.5c1.3,0,2.2-.4,2.9-1,.3-.2.3-.5,0-.9l-.3-.4c-.3-.3-.5-.3-.9,0-.5.3-1.2.5-1.8.5-1.9,0-3.1-1.3-3.1-2.9,0-1.7,1.1-3,3-3.1.6,0,1.2.1,1.8.4.4.2.7.2.9-.1l.3-.4c.2-.3.2-.7-.2-.9-.8-.5-1.7-.8-2.9-.8-3.2,0-5.1,2.4-5.1,5,0,2.6,2.1,4.8,5.3,4.7M71.9,58.3v-4.1c.1,0,2.6,3.2,2.6,3.2l-2.6.9ZM70.6,62.4l.8-.3c.3-.1.5-.4.5-.7v-1.3s3.5-1.2,3.5-1.2l.8,1c.2.3.5.4.9.2l.8-.3c.5-.2.5-.5.2-.9l-5.7-6.7c-.2-.3-.5-.4-.9-.2l-.9.3c-.4.1-.5.4-.6.7l-.4,8.8c0,.5.3.7.7.5M64.2,55.2l-4.3,2.8c-.4.2-.4.5-.2.9l4.4,6.9c.2.4.6.4.9.2l.7-.5c.4-.2.4-.5.2-.9l-1.7-2.7,2.6-1.7c.4-.2.4-.6.2-.9l-.2-.3c-.2-.4-.5-.4-.9-.2l-2.6,1.7-1.2-1.8,3.1-2c.4-.2.4-.5.2-.9l-.3-.4c-.2-.4-.5-.4-.9-.2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCimNohEasyFr);
export default __webpack_public_path__ + "static/media/cim_noh_easy_fr.2733ca54a7a1bd6e39e508eb22373f99.svg";
export { ForwardRef as ReactComponent };